// extracted by mini-css-extract-plugin
export var resizer = "_gs-0";